import { useGenererArgumentaire } from "@features/fiche/hooks";
import { BoutonCopier } from "@shared/ui/BoutonCopier";

type Bloc = { type: string; objet: string | null; contenu: string; version: number };
type Objection = { id: string; objection: string; reponse: string; probabilite: string };

const LIBELLES: Record<string, string> = {
  resume: "Résumé d'activité", constat: "Constat chiffré", accroche: "Accroche téléphone",
  question_ouverte: "La question — se taire après", barrage: "Franchir le barrage",
  suite: "Enchaînement après sa réponse", email: "E-mail", email_relance: "Relance"
};

export function PanneauArgumentaire({ prospectId, blocs, objections }: {
  prospectId: string; blocs: Bloc[]; objections: Objection[];
}) {
  const generer = useGenererArgumentaire(prospectId);

  return (
    <>
      <div className="panel ligne">
        <button className="btn" onClick={() => generer.mutate()} disabled={generer.isPending}>
          {generer.isPending ? "Génération en cours…" : blocs.length ? "Régénérer" : "Générer l'argumentaire"}
        </button>
        {generer.isError && <span className="erreur">{(generer.error as Error).message}</span>}
      </div>

      {blocs.length === 0 && !generer.isPending && (
        <p className="etat">Aucun argumentaire pour l'instant. La génération prend une vingtaine de secondes.</p>
      )}

      {blocs.map(b => (
        <section key={b.type} className="panel">
          <h2 className="blocktitle">
            {LIBELLES[b.type] ?? b.type} <span className="mut">v{b.version}</span>
            {b.objet && <> — objet : {b.objet}</>}
          </h2>
          <div className={`script ${b.type.startsWith("email") ? "mail" : ""}`}>{b.contenu}</div>
          <div style={{ marginTop: 9 }}><BoutonCopier texte={b.contenu} /></div>
        </section>
      ))}

      {objections.length > 0 && (
        <section className="panel">
          <h2 className="blocktitle">Objections</h2>
          {objections.map(o => (
            <details key={o.id}>
              <summary>{o.objection} <span className="mono petit mut">· {o.probabilite}</span></summary>
              <p className="rep">{o.reponse}</p>
            </details>
          ))}
        </section>
      )}
    </>
  );
}
